import { Box } from "@mui/material";
import CardComponent from "./CardComponent";
import TrackerType from "./TrackertypeComponent";
import DashboardBomTable from "./DashboardBomTable";
import { useState } from "react";

const ProgressComponent = (props) => {
    const { 
        data = {}, 
        loader, 
        setCurrentSelection, 
        setSelectedRow, 
        selectPart, 
        setActivities, 
        setActivityType,
        handleClickTracker, 
        trackers, 
        selectedRow, 
        isSvg, 
        activity,
        setSection,
        setTracker,
        currentProject,
        setPartId
    } = props;
    const { 
        constructionList = {}, 
        progressList = [], 
        trackerList = [],  
        partTrackerTypes = {},
        bomTrackerTypes = {},
        projectBom = {}, 
        blocks = [],
        bulkAllData,
        pierlegends
    } = data;
    const { construction } = constructionList;
    const [checked, setChecked] = useState(false);

    return (
        <Box sx={{ p: 2, height: 'calc(100vh - 120px)', overflowY: 'auto' }}>
            <DashboardBomTable 
                selectPart={selectPart} 
                checked={checked} 
                setChecked={setChecked} 
                isSvg={isSvg}
                selectedRow={selectedRow} 
            />
            <CardComponent
                title="Construction Progress"
                loader={loader}
                construction={construction}
                progressList={progressList}
                setCurrentSelection={setCurrentSelection}
                checked={checked}
                selectPart={selectPart}
                setActivities={setActivities}
                setActivityType ={setActivityType}
                selectedRow={selectedRow}
                activity={activity}
                partTrackerTypes={partTrackerTypes}
                bomTrackerTypes={bomTrackerTypes}
                projectBom={projectBom}
                blocks={blocks}
                trackerList={trackerList}
                setSelectedRow={setSelectedRow}
                bulkAllData={bulkAllData}
                pierlegends={pierlegends}
                setSection={setSection}
                setTracker={setTracker}
                currentProject={currentProject}
                setPartId ={setPartId}
            />
            <TrackerType
                trackerList={trackerList}
                loader={loader}
                handleClickTracker={handleClickTracker}
                trackers={trackers}
                selectedRow={selectedRow}
            />
        </Box>
    );
};

export default ProgressComponent;
